import { Box, Button, Heading, Text } from '@zillow/constellation-10';
import type { CreditReportType } from '@zg-rentals/ts-capps-client';
import type { UserStatus } from '../../../graphql/queries';
import { CreditReportAlertSmall, isCreditReportViewable } from '../BackgroundReport/BackgroundReportAlert';
import { getIsCreditReportValid } from '../../../utils/user-statuses';

export function CreditReportOverview({
  creditReport,
  userStatuses,
  onView,
}: {
  creditReport?: CreditReportType;
  userStatuses: Array<UserStatus>;
  onView: () => void;
}) {
  const isCreditReportValid = getIsCreditReportValid(userStatuses);
  const creditReportVisible = isCreditReportViewable(creditReport);
  const creditScoreDisplay =
    isCreditReportValid && creditReportVisible && creditReport ? creditReport.creditScore || 'N/A' : '-';

  return (
    <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tighter' }}>
        <Heading level={2} textStyle="responsive.heading-sm">
          Credit report
        </Heading>
        <CreditReportAlertSmall creditReport={creditReport} />
        <Heading level={3} textStyle="responsive.heading-xs" css={{ color: 'text.subtle' }}>
          Credit score
        </Heading>
        <Text>
          <strong>{creditScoreDisplay}</strong>
        </Text>
      </Box>
      <Button
        size="sm"
        onClick={onView}
        disabled={!isCreditReportValid || !creditReportVisible}
        aria-label="View credit report"
      >
        View
      </Button>
    </Box>
  );
}
